<template>
  <div>
    <div class="title">{{ $t('app.news') }}</div>
    <table class="table is-fullwidth is-striped">
      <thead>
        <tr>
          <th>{{ $t('app.datetime') }}</th>
          <th>{{ $t('app.title') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data.slice(1)" v-bind:key="item.id">
          <td>{{ item[1] }}</td>
          <td>
            <a v-on:click="readNews(item[0])">{{ item[5] }}</a>
          </td>
        </tr>
      </tbody>
    </table>
    <center v-if="limit == 5">
      <a v-on:click="more()">{{ $t('app.more') }}</a>
    </center>

    <div class="modal" v-bind:class="{'is-active': modalDisplay}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t('app.news') }}</p>
          <button class="delete" aria-label="close" v-on:click="closeModal()"></button>
        </header>
        <section class="modal-card-body" v-html="news"></section>
        <footer class="modal-card-foot">
          <button class="button" v-on:click="closeModal()">{{ $t('app.close') }}</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import iconv from "iconv-lite";
import { mapState } from "vuex";

export default {
  props: {
    limit: {
      default: 30
    }
  },
  computed: {
    ...mapState(["symbol"])
  },
  data: function() {
    return {
      data: [],
      modalDisplay: false,
      news: null
    };
  },
  mounted: function() {
    axios
      .get(
        process.env.VUE_APP_PROXY +
        "cmd=HaberFirmaBasliklar?adet=" +
          this.limit +
          "?symbol=" +
          this.symbol,
        { responseType: "arraybuffer", responseEncoding: "binary" }
      )
      .then(response => this.parseResponse(response));
  },
  methods: {
    parseResponse: function(response) {
      let data = iconv.decode(Buffer.from(response.data), "ISO-8859-9");
      let rows = data.split("\n");
      rows.forEach(row => {
        this.data.push(row.split("|"));
      });
    },
    readNews: function(id) {
      axios
        .get(
          process.env.VUE_APP_PROXY +
          "cmd=HaberIcerik?id=" +
            id +
            "?lang=" +
            this.$i18n.locale,
          { responseType: "arraybuffer", responseEncoding: "binary" }
        )
        .then(response => this.openModal(response));
    },
    openModal: function(response) {
      this.news = iconv
        .decode(Buffer.from(response.data), "ISO-8859-9")
        .replace(/(?:\r\n|\r|\n)/g, "<br />");
      this.modalDisplay = true;
    },
    closeModal: function() {
      this.modalDisplay = false;
    },
    more: function() {
      this.$parent.setActive("Haberler");
    }
  }
};
</script>